import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

import { LayoutClasses } from './types';

export interface LayoutStyledProps {
  variant?: 'filled' | 'outlined';
}

export const LayoutStyled = styled('div')<LayoutStyledProps>(
  ({ theme, variant = 'filled' }) => ({
    ...(variant === 'filled' && {
      backgroundColor:
        theme.palette.mode === 'light' ? Colors.white : Colors.gray200,
    }),

    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',

    [`.${LayoutClasses.content}`]: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      marginTop: 24,
    },

    [`.${LayoutClasses.footer}`]: {
      height: 72,
    },
  })
);
